import { Component, OnInit, Input } from '@angular/core';

// -----------------------------------------------------------------
// LIBRARIES/LIBRERIAS
// -----------------------------------------------------------------
import * as firebase from 'firebase';
import { User } from '../../../models/user.model';
import { Router } from '@angular/router';

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {

    @Input() user: User

    constructor(
        private router: Router
    ) { }

    ngOnInit() {
    }

    signOut() {
        // window.alert('ha presionado cerrar sesión')
        localStorage.clear();
        firebase.auth().signOut().then(() => {
            this.router.navigate(['/']);
        })
    }
}



// WEBPACK FOOTER //
// ./src/app/components/user/sidebar/sidebar.component.ts